module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B2VHLS3.cd387560.jpg";